module.exports = "<div class=\"btn-matrix-container\">\r\n\r\n  <div class=\"jumbotron\">\r\n    <h2>Sie werden nun zu der Touch-Oberfläche von eStore+ weitergeleitet...</h2>\r\n    <p>\r\n      <a class=\"btn btn-default\" role=\"button\" (click)=\"onCancelClicked()\">Abbrechen und zurück zu VisBOS touch!</a>\r\n    </p>\r\n  </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/visbos-touch-client/ui/vtouch/redirect-to-vtouch/redirect-to-vtouch.component.html
// module id = ./src/app/visbos-touch-client/ui/vtouch/redirect-to-vtouch/redirect-to-vtouch.component.html
// module chunks = main